// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d853a216","211":"21a6d786","324":"85502ad7","510":"811737f7","678":"7323e7d4","680":"0b2a2b00","751":"bedcda82"}[chunkId] + ".chunk.js";
};